module.exports = __webpack_public_path__ + "static/img/RS4266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS4266_1.png
// module id = 1DU1
// module chunks = 0